import { useQuery } from '@tanstack/react-query';

import { getStandingsQuery } from '@shared/queries/standings';
import type { StandingsOptions } from '@shared-types/standing.types';
import { IS_TEST } from '@utilities/browser';

export const useStandings = ({ cup, season, phase, groupId, roundId, isDomestic }: StandingsOptions) => {
  const {
    data: standings,
    isLoading,
    isFetched,
  } = useQuery({
    ...getStandingsQuery({
      isDomestic,
      competitionId: cup,
      seasonYear: season,
      phase,
      groupIds: groupId,
      roundId,
    }),
    refetchInterval: !isDomestic && !IS_TEST && 10000,
    select: (data) => data?.filter((s) => s.group || s.name).filter((s) => s.items?.length) ?? [],
  });

  return {
    standings,
    isLoading,
    isFetched,
  };
};
